import { Component, HostListener, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-scroll-top',
  templateUrl: './scroll-top.component.html',
  styleUrls: ['./scroll-top.component.scss'],
})
export class ScrollTopComponent {
  windowScrolled = false;
  topOffset = 150; // Top offset to display scroll-to-top button

  constructor(@Inject(DOCUMENT) private document: Document) {}

  @HostListener('window:scroll', [])
  onWindowScroll() {
    // Use modern API to get scroll position
    const scrollPosition = window.scrollY || document.documentElement.scrollTop;
    this.windowScrolled = scrollPosition > this.topOffset;
  }

  scrollToTop() {
    // Use native smooth scrolling for consistent behavior
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }
}
